import { Drawer as DrawerAntd, DrawerProps } from 'antd';

export const Drawer = (props: DrawerProps) => {
  return <DrawerAntd {...props} />;
};
